import { cn } from "@/core/helpers/cn";

type Props = {
  leftActive: boolean;
  rightActive?: boolean;
  className?: string;
  classNameLeft?: string;
  classNameRight?: string;
};

export default function FactionImprovementsLine({
  leftActive,
  rightActive,
  className,
  classNameLeft,
  classNameRight,
}: Props) {
  return (
    <div className={cn("absolute top-1/2 left-[5.375rem] w-[5.3125rem] h-25", className)}>
      <div
        className={cn(
          "absolute top-0 left-0 w-[calc(50%+0.03125rem)] h-full border-t border-r transition-all duration-200",
          leftActive
            ? "border-t-accent-solid border-r-accent-solid z-2"
            : "border-t-[#212121] border-r-[#212121] z-1",
          classNameLeft,
        )}
      />
      <div
        className={cn(
          "absolute top-0 right-0 w-[calc(50%+0.03125rem)] h-full border-t border-l transition-all duration-200",
          rightActive
            ? "border-t-accent-solid border-l-accent-solid z-2"
            : "border-t-[#212121] border-l-[#212121] z-1",
          classNameRight,
        )}
      />
    </div>
  );
}
